<template>
  <!-- <div id="workbench"></div> -->
  <div id="view-reviews">
    <div class="ipub-h1 relative mar-b-10">
      Reviews Details
    </div>
    <div class="mar-b-30">
      <div v-for="(item,index) in responseData"
           :key="index"
           class="content-bg"
           style="padding-bottom:10px">
        <div class="ipub-h3 line-h-40 mar-b-10 ipub-title-tab"
             @click="togalReport(item,'showReport')">
          Report {{responseData.length-index}}
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',!item.showReport?'rotate-180':'']"
                     type="iconArrow" />
        </div>

        <div v-if="!item.showReport"
             class="ipub-title-tab-part">
          <div class="mar-b-12">
            <span style="margin-right:12px;"
                  class="ipub-p2 fw-bd">Reviewer Decision <font class="key-color">*</font></span> <span class="ipub-p2 fw-bd">{{decisionStatus[item.decisionStatus]}}</span>
          </div>
          <div class="mar-b-20">
            <div class="mar-b-20">
              <div class="ipub-p2 fw-bd relative mar-b-10">
                Custom Review Questions
              </div>
              <customerReviewQuestion :questionList="item.questionList"></customerReviewQuestion>
            </div>

            <div>
              <div class="ipub-p2 fw-bd relative mar-b-10"
                   style="cursor:pointer">
                Comments to Editor
                <ipub-icon :class="['ipub-p5 mar-l-20 rotate ipub-cursor-pointer',!item.showEditor?'rotate-180':'']"
                           @click="togalReport(item,'showEditor')"
                           type="iconArrow" />
              </div>
              <div class="ipub-p2 mar-b-20 "
                   v-if="!item.showEditor">
                <div class="ipub-p2"
                     v-if="item.editorNotes"
                     v-html="item.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>

                <template v-else>
                  <div class="line-color">No notes or comments.</div>
                </template>

              </div>
            </div>

            <div>
              <div class="ipub-p2 fw-bd relative mar-b-10"
                   style="cursor:pointer">
                Comments to Author
                <i class="key-color">*</i>
                <ipub-icon :class="['ipub-p5 mar-l-20 rotate ipub-cursor-pointer',!item.showAuthor?'rotate-180':'']"
                           @click="togalReport(item,'showAuthor')"
                           type="iconArrow" />
              </div>
              <div class="ipub-p2 mar-b-20"
                   v-if="!item.showAuthor">
                <div class="ipub-p2"
                     v-if="item.authorNotes"
                     v-html="item.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>

                <template v-else>
                  <div class="line-color">No notes or comments.</div>
                </template>
              </div>
            </div>

            <div v-if="item.reviewerFileList && item.reviewerFileList.length>0">
              <div>
                <div class="ipub-p2 fw-bd mar-b-12">Attachment(s)</div>
                <div>
                  <ipub-label class="ipub-p2"
                              style="margin-right:12px;cursor:pointer;"
                              v-for="(itemfile) in item.reviewerFileList"
                              :key="itemfile.id"
                              hover
                              @click="download(itemfile)">
                    {{itemfile.name}}
                    <ipub-icon class="mar-l-10"
                               type="iconDownload1" />
                  </ipub-label>
                </div>

              </div>
            </div>
          </div>
          <!-- 作者回复 -->
          <div class="mar-b-40">
            <div class="ipub-p2 fw-bd relative mar-b-10"
                 style="cursor:pointer"
                 v-if="item.authorReply || (item.authorReplyFileList && item.authorReplyFileList.length>0)">
              Author’s Response to Report {{responseData.length-index}}
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',!item.showReply?'rotate-180':'']"
                         @click="e => togalReport(item,'showReply')"
                         type="iconArrow" />
            </div>
            <div v-if="!item.showReply">
              <div v-if="item.authorReply">
                <div class="ipub-p2 fw-bd relative mar-b-10"
                     style="cursor:pointer">
                  Author’s Response
                </div>
                <div class="ipub-p2 mar-b-30 font-color">
                  {{item.authorReply}}
                </div>
              </div>

              <div v-if="item.authorReplyFileList && item.authorReplyFileList.length>0">
                <div>
                  <div class="ipub-p2 fw-bd  mar-b-10">Author’s Response File</div>
                  <ipub-label class="ipub-cursor-pointer mar-b-10"
                              style="margin-right:12px;"
                              hover
                              v-show="itemReply.authorShowed"
                              v-for="(itemReply) in item.authorReplyFileList"
                              :key="itemReply.id"
                              @click="download(itemReply)">
                    {{itemReply.name}}
                  </ipub-label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="ipub-p2 mar-b-20">
      <div>Thank you very much for your review of the following manuscript.</div>
      <div>You can download the review certificate by clicking the button below</div>
    </div>

    <ipub-button type="primary"
                 @click="createCanvans('rc-c')"
                 style="min-width:230px">
      Download Certificate </ipub-button> -->
    <CreatePNG :isVisable="isVisablePDF"
               :inputData="inputData"
               :edit="false"
               :open="true"
               :type="pdfType"
               :journalId="journalInfo.journal && journalInfo.journal.id"
               @confirm="cancel"
               @cancel="cancel" />

  </div>
</template>



<script>
import main from './main'
export default main

</script>

<style lang="scss" scoped>
@import './main.scss';
</style>
